PageVue
  .fp-vertical-spacing.-s-lg(v-if='!authorizations.isLoading()')
    .fp-vertical-spacing--line
      GlobalStatisticsVue(:show-statistics='hasAuthorization("clubs-read-orders")')
    template(v-if='hasAuthorization("clubs-read-orders")')
      .fp-separator.-secondary
      .fp-vertical-spacing--line
        .fp-horizontal-spacing.-s-sm.-items-center
          .fp-horizontal-spacing--column
            i.fp-icon.fp-glyph-shopping-cart.-s18
          .fp-horizontal-spacing--column
            h2.fp-title.-color-shade-700
              span(v-if='club.isMarketplace' data-test='orders-title') {{ t('home.orders.title') }}
              span(v-else data-test='orders-title-foundation') {{ t('home.orders.titleFoundation') }}
      .fp-vertical-spacing--line
        OrdersTableVue
    template(v-if='hasAuthorization("clubs-read-donations") && club.isFoundation')
      .fp-separator.-secondary
      .fp-vertical-spacing--line
        .fp-horizontal-spacing.-s-sm.-items-center
          .fp-horizontal-spacing--column
            i.fp-icon.fp-glyph-hand-heart.-s18
          .fp-horizontal-spacing--column
            h2.fp-title.-color-shade-700 {{ t('home.donations.title') }}
      .fp-vertical-spacing--line
        DonationsTableVue
